<template>
    <div class="select-opt" :class="{ 'select-active': isClicked }">
        <div class="select-txt" @click="handleClick">{{ currentHours }}</div>
        <ul class="select-div scroll-tracker">
            <li :class="{ on: currentHours === item }" @click="handleItemClick(item)" v-for="(item, idx) in hoursData" :key="idx">
                {{ item }}
            </li>
        </ul>
        <select>
            <option></option>
        </select>
    </div>
</template>

<script>
export default {
    name: "CalendarHours",
    props: ["hoursData", "current"],
    data() {
        return {
            isClicked: false,
            currentHours: this.current
        };
    },
    methods: {
        handleClick() {
            this.isClicked = !this.isClicked;
        },
        handleItemClick(data) {
            this.currentHours = data;
            this.isClicked = false;
            this.$emit("setHoursData", this.currentHours);
        }
    }
};
</script>

<style lang="scss" scoped>
.select-opt {
    display: inline-block;
    width: 56px;
    padding: 3px 12px;
    position: relative;
    margin-right: 8px;
    font-size: 12px;
    box-sizing: border-box;
    border: solid 1px #d8e4f0;
    border-radius: 4px;
    background: #fff;
    cursor: pointer;
    .select-txt {
        border: none;
        padding: 0;
        width: 90%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    select {
        display: none;
    }
    &::after {
        top: 8px;
        width: 6px;
        height: 10px;
        display: inline-block;
        background: url($zhijiStaticImagePath+"class-spr.png");
        background-position: -127px -20px;
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
    }
    .select-div {
        position: absolute;
        width: 100%;
        left: 0;
        top: auto;
        bottom: 34px;
        background: #fff;
        display: none;
        border-radius: 4px;
        z-index: 1;
        max-height: 211px;
        overflow-y: auto;
        box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);

        > li {
            padding: 6px 12px;
            cursor: pointer;
            &:hover,
            &.on {
                color: #2ec2ff;
            }
            &:hover {
                background: rgba(217, 235, 246, 0.7);
            }
            &.on {
                background: rgba(217, 235, 246, 1);
            }
        }
    }
}
.select-active {
    border-color: #2088f3;
    .select-div {
        display: block;
    }
    &::after {
        transform: rotate(180deg);
    }
}
</style>
